import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { IS_NOT_EMPTY } from 'cargo-chief-commons';

@Component({
	selector: 'app-confirm-text-dialog',
	templateUrl: './confirm-text-dialog.component.html',
})
export class ConfirmTextDialogComponent implements OnInit {
	IS_NOT_EMPTY = IS_NOT_EMPTY;

	formContent: UntypedFormControl;

	constructor(
		public dialogRef: MatDialogRef<ConfirmTextDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public utilService: UtilService
	) {}

	ngOnInit() {
		this.formContent = new UntypedFormControl('');
	}

	ngOnChanges() {}

	closeDialog(): void {
		this.dialogRef.close(null);
	}

	confirm(): void {
		let description = this.formContent.value.trim();
		if (IS_NOT_EMPTY(description)) {
			this.dialogRef.close(description);
		} else {
			this.utilService.showSnackbar(this.data.errorMessage, SNACKBAR.ERROR, SNACKBAR.ACTION);
		}
	}
}
